import { createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../api/api";

export const getCommonQuizTopicThunk = createAsyncThunk(
  "commonquiz/get",
  async (data) => {
    let response = await api.get(`getMasterTtlQuizTopics/${data.usertype}/${data.module}/${data.language}`);
    return response.data;
  }
);

export const getTeacherAssessmentThunk = createAsyncThunk(
  "commonquiz/getquiz",
  async (data) => {
    let response = await api.get(`getMasterTtlQuizQuestions/${data.usertype}/${data.language}/${data.topicId}`);
    return response.data;
  }
);

export const createTeacherAssessmentThunk = createAsyncThunk(
  "assessment/create",
  async (body) => {
    let response = await api.post("saveMasterTtlQuizQuestions", body);
    return response.data;
  }
);

export const updateTeacherAssessmentThunk = createAsyncThunk(
  "assessment/update",
  async (reqbody) => {
    const id = reqbody._id;
    const { _id, ...body } = reqbody; // remove _id from reqbody and create new object called body
    let response = await api.put("updateMasterTtlQuizTopic/" + id, body);
    return response.data;
  }
);

export const deleteTeacherAssessmentThunk = createAsyncThunk(
  "assessment/delete",
  async (id) => {
    let response = await api.delete("deleteMasterTtlQuizTopic/" + id);
    return response.data;
  }
);
